import type { ServerAction } from "@/types/domain";
import type { ServerResponse } from "@/types/network";
import { apiSlice } from "@features/application/api-slice";

export interface PersonalAccessTokenRoot {
  readonly actions?: ServerAction[];
}

interface AdminUserinfo {
  readonly contributors?: Record<string, unknown>;
}

export interface PersonalAccessTokenOwnerContext {
  readonly workspaceIds: readonly string[];
}

const toOwnerContext = (
  response: ServerResponse<AdminUserinfo>,
): PersonalAccessTokenOwnerContext => ({
  workspaceIds: Object.keys(response.data?.contributors ?? {}),
});

export const personalAccessTokenContextApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPersonalAccessTokenRoot: builder.query<PersonalAccessTokenRoot | undefined, void>({
      query: () => "/root",
      transformResponse: (response: ServerResponse<PersonalAccessTokenRoot>) => response.data,
    }),
    getPersonalAccessTokenOwnerContext: builder.query<PersonalAccessTokenOwnerContext, number>({
      query: (contributorId) => ({
        url: "/admin/userinfo",
        params: { "contributor-id": contributorId },
      }),
      transformResponse: toOwnerContext,
    }),
  }),
  overrideExisting: false,
});

export const { useGetPersonalAccessTokenRootQuery, useGetPersonalAccessTokenOwnerContextQuery } =
  personalAccessTokenContextApi;
